import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { Stat } from 'Packages/FacetDesign/Components';
import { BackwardsLozengeStat } from './backwardsLozengeStat';

export const AUMResponsesOverride = buildFacetDesignOverride()
  .nameOverride(['prospectCurrentlyHasAum', 'prospectPlansToInvest'], { _component: () => BackwardsLozengeStat }, overrideReadOnly)
  .nameOverride(['reasonProspectWillNotInvest', 'otherReasonProspectWillNotInvest'], { _component: () => Stat }, overrideReadOnly);
